import { Component, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { InitializationService } from '../../../services/initialization.service';

@Component({
    selector: 'app-simbologia',
    templateUrl: './simbologia.component.html',
    styleUrls: ['./simbologia.component.css'],
})
export class SimbologiaComponent {
    @ViewChild('simbologia_modal', { static: true })
    simbologia_modal: ModalDirective;

    constructor(private _config: InitializationService) {}

    simbolos = [];

    async set_simbolos() {
        let root = 'ayuda.simbologia.simbolos';
        this.simbolos = [
            {
                icon: this._config.getIcon('navegacion'),
                titulo: `${root}.navegacion.nombre`,
                glosa: `${root}.navegacion.glosa`,
                subs: null,
            },
            {
                icon: this._config.getIcon('goback_portal'),
                titulo: `${root}.portal.nombre`,
                glosa: `${root}.portal.glosa`,
                subs: null,
            },
            {
                icon: this._config.getIcon('noticias'),
                titulo: `${root}.novedades.nombre`,
                glosa: `${root}.novedades.glosa`,
                subs: null,
            },
            {
                icon: this._config.getIcon('avisos'),
                titulo: `${root}.avisos.nombre`,
                glosa: `${root}.avisos.glosa`,
                subs: null,
            },
            {
                icon: this._config.getIcon('ayuda'),
                titulo: `${root}.ayuda.nombre`,
                glosa: `${root}.ayuda.glosa`,
                subs: [
                    {
                        icon: this._config.getIcon('contacto'),
                        titulo: `${root}.ayuda.subs.contacto.nombre`,
                        glosa: `${root}.ayuda.subs.contacto.glosa`,
                    },
                    {
                        icon: this._config.getIcon('simbologia'),
                        titulo: `${root}.ayuda.subs.simbologia.nombre`,
                        glosa: `${root}.ayuda.subs.simbologia.glosa`,
                    },
                    {
                        icon: this._config.getIcon('tutorial'),
                        titulo: `${root}.ayuda.subs.tutorial.nombre`,
                        glosa: `${root}.ayuda.subs.tutorial.glosa`,
                    },
                ],
            },
            {
                icon: this._config.getIcon('modulos_aplicaciones'),
                titulo: `${root}.modulos_apps.nombre`,
                glosa: `${root}.modulos_apps.glosa`,
                subs: null,
            },
            {
                icon: this._config.getIcon('usuario'),
                titulo: `${root}.usuario.nombre`,
                glosa: `${root}.usuario.glosa`,
                subs: [
                    {
                        icon: this._config.getIcon('micuenta'),
                        titulo: `${root}.usuario.subs.profile.nombre`,
                        glosa: `${root}.usuario.subs.profile.glosa`,
                    },
                    {
                        icon: this._config.getIcon('correouv'),
                        titulo: `${root}.usuario.subs.correo.nombre`,
                        glosa: `${root}.usuario.subs.correo.glosa`,
                    },
                    {
                        icon: this._config.getIcon('cambiaclave'),
                        titulo: `${root}.usuario.subs.cambiaclave.nombre`,
                        glosa: `${root}.usuario.subs.cambiaclave.glosa`,
                    },
                    {
                        icon: this._config.getIcon('logout'),
                        titulo: `${root}.usuario.subs.logout.nombre`,
                        glosa: `${root}.usuario.subs.logout.glosa`,
                    },
                ],
            },
        ];
        this.simbologia_modal.show();
    }
}
